import * as duckdb from '@duckdb/duckdb-wasm';
import { DirectedGraph } from 'graphology'; // Use a graph library for the DAG
import { topologicalSort } from 'graphology-dag';


export async function runPipeline(
  info: any, 
  duckCon: duckdb.AsyncDuckDBConnection,
  setProgress: any
) {
  let sequence = getRunSequence(info.dag);
  const sqlDict = Object.fromEntries(
    info.sql.map((item: any) => [item.name.split(".")[0], item.sql]));
  for (const sequenceItem of sequence) {
    setProgress(`${sequenceItem}`);
    try {
      let sql = `create or replace table ${sequenceItem} as ${sqlDict[sequenceItem]}`;
      await duckCon.query(sql);
      // let res = await queryDuck(`from ${sequenceItem}`, duckCon);
    } catch (error) {
      console.warn(`Error in ${sequenceItem}`);
      continue;
    }
  }
  return sequence;
}

function getRunSequence(dag: any): any {
  const edgeList: [string, string][] = dag.flatMap((item: any) => [
    ...item.input.map((inputItem: string) => [inputItem, item.name]),
    ["__root", item.name]
  ]);
  const G = new DirectedGraph();
  const nodeList = Array.from(new Set(edgeList.flatMap(item => item)));
  nodeList.forEach(node => G.addNode(node));
  edgeList.forEach((edge: [string, string]) => G.addEdge(edge[0], edge[1]));
  const sequence = topologicalSort(G).filter((node: string) => node !== '__root');
  return sequence;
}
